import { LitElement, html, css, type CSSResultGroup, type TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("search-box")
export class HeaderContainer extends LitElement {
  static styles: CSSResultGroup = css`
    :host {
}
.search__input {
}
.menu__button{
  display: flex;
  padding: var(--spacing-80) var(--spacing-40);
  align-items: center;
  gap: var(--spacing-15);
  cursor: pointer;
  border: none;
  background-color: var(--bg-white);
}
  .title{
  font-size: var(--text-md);
  font-weight: var(--text-semibold);
  line-height: var(--text-lg-line-height);
  }
  .searchinput__container{
  position: absolute;
    top: 104px;
    left: 0;
    width: 100%;
    height: 3rem;
    
    }
    .searchinput__content{
      width: 100%;
      height: 100%;
      max-width: var(--site-max-width);
      margin: auto;
    position: relative;
    }
    .searchinput__input{
    width: 100%;
    height: 100%;
    padding-left: 3rem;
    margin: auto;
    box-sizing: border-box;
    max-width: var(--site-max-width);
    }
    .searchbutton{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 1rem;
    height: 1rem;
    width: 1rem;
    background: transparent;
    border: none;
    cursor: pointer;
    }
    .searchbutton__icon{
    height: 1rem;
    width: 1rem;
    }
  `;

  @property({ type: Boolean, reflect: true }) open = false;

  private _toggle = (): void => {
    this.open = !this.open;
  };

  private handleSearch = (e: Event): void => {
    e.preventDefault();
    const query = (this.shadowRoot?.querySelector("#header-search-input") as HTMLInputElement)?.value ?? "";
    location.href = this.searchUrl + "?query="+query;
  };

  private searchUrl: string;
  private searchInput: HTMLInputElement | null;

  constructor() {
    super();
    this.searchInput = document.querySelector("search-box")?.shadowRoot?.querySelector("#header-search-input") ?? null
    this.searchUrl = this.getAttribute("searchUrl") ?? "";
  }
  render(): TemplateResult {
    return html`
    <button class="menu__button" @click=${this._toggle}>
      <slot name="searchicon"></slot>
      <span class="title">Sök</span>
      
    </button>
    <div class="searchinput__container" style=${!this.open ? "display:none" : ""}>
    <div class="searchinput__content">
      <button class="searchbutton" @click=${this.handleSearch}>
      <div class="searchbutton__icon">
      
      <slot name="searchicon2" class=""></slot>
      
      </div>
      </button>
      <form action="/sok/" method="get" style="display: contents;" @submit=${this.handleSearch}>
        <input id="header-search-input" type="text" class="searchinput__input">
        </form>
        </div>
      <div>
    `;
  }
}
